import React, { ReactNode } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { Dropdown, DropdownProps, Option } from '../dropdown';

type DropdownWrapperOption<TValue extends NonNullable<unknown>> = {
    id: TValue;
    label: ReactNode;
    disabled?: boolean;
};

type DropdownWrapperProps<
    TValue extends NonNullable<unknown>,
    Multiple extends boolean = false,
> = Omit<DropdownProps<TValue, Multiple>, 'children'> & {
    options: DropdownWrapperOption<TValue>[];
    showCheckIcon?: boolean;
};

const DropdownWrapper = React.forwardRef(function DropdownWrapper<
    TValue extends NonNullable<unknown>,
    Multiple extends boolean = false,
>(
    { options, showCheckIcon, ...props }: DropdownWrapperProps<TValue, Multiple>,
    ref: React.ForwardedRef<HTMLButtonElement>,
) {
    return (
        <Dropdown {...props} ref={ref}>
            {options.map(option => (
                <Option key={option.id as React.Key} value={option.id} disabled={option.disabled}>
                    <span>{option.label}</span>
                    {showCheckIcon ? <CheckIcon fontSize="small" /> : null}
                </Option>
            ))}
        </Dropdown>
    );
});

export { DropdownWrapper };
export type { DropdownWrapperOption, DropdownWrapperProps };
